import { inject } from '@angular/core';
import { LocationService } from './location.service';
import { ResolveFn } from '@angular/router';

export const countriesResolver: ResolveFn<void> = async () => {
  await inject(LocationService).setCountries();
}
